import { Typography } from "@p0security/ui";
import { format, formatDistanceToNow, formatISO } from "date-fns";

const { Text } = Typography;

export const Timestamp: React.FC<{ at: number; copyable?: boolean }> = ({
  at,
  copyable,
}) =>
  at ? (
    <div className="flex flex-col">
      <div>
        <Text copyable={copyable ? { text: formatISO(at) } : false}>
          {format(at, "PPP")}
        </Text>
      </div>
      <div>
        <Text
          type="secondary"
          /* eslint-disable-line react/forbid-component-props */ style={{
            fontSize: "small",
          }}
        >
          {formatDistanceToNow(at, { addSuffix: true })}
        </Text>
      </div>
    </div>
  ) : (
    <Text type="secondary">(Never)</Text>
  );
